module.exports = __webpack_public_path__ + "openstack.logo.0c26b.png";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/openstack/src/logo/openstack.logo.png
// module id = 3759
// module chunks = 0